import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { TranslationService } from '@trimble-gcs/i18n';
import { ModusButtonModule, ModusIconModule, ModusTooltipModule } from '@trimble-gcs/modus';
import { DashedIfEmptyPipe, FileSizePipe } from '@trimble-gcs/ngx-common';
import { LabelValueComponent } from '../../../../label-value/label-value.component';
import { ScandataModel } from '../../../../scandata/scandata.models';
import { multiSelectedTranslations } from './multi-selected.translations';

@Component({
  selector: 'sd-recycle-bin-multi-selected',
  standalone: true,
  imports: [
    CommonModule,
    ModusButtonModule,
    ModusIconModule,
    ModusTooltipModule,
    LabelValueComponent,
    FileSizePipe,
    DashedIfEmptyPipe,
  ],
  templateUrl: './multi-selected.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultiSelectedComponent {
  private readonly translationService = inject(TranslationService);

  readonly selectedScans = input.required<ScandataModel[]>();
  readonly disabled = input(false);

  readonly closeClicked = output();

  readonly translations = multiSelectedTranslations();

  readonly title = computed(() =>
    this.translationService.translate(this.translations.title.text, {
      count: this.selectedScans().length,
    }),
  );

  readonly totalSize = computed(() =>
    this.selectedScans().reduce((acc, scan) => acc + scan.fileSize, 0),
  );
}
